import { render } from "./BeneficiosClaveNew.vue?vue&type=template&id=14fdc771&scoped=true"
import script from "./BeneficiosClaveNew.vue?vue&type=script&lang=js"
export * from "./BeneficiosClaveNew.vue?vue&type=script&lang=js"

import "./BeneficiosClaveNew.vue?vue&type=style&index=0&id=14fdc771&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14fdc771"]])

export default __exports__